import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/', { replace: true });
      return;
    }
    const sid = match[1];

    (async () => {
      try {
        const { data } = await api.post('/auth/session', { session_id: sid });
        setUser(data.user);
        window.history.replaceState({}, '', '/dashboard');
        navigate('/dashboard', { replace: true, state: { user: data.user } });
      } catch (e) {
        navigate('/', { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="flex items-center gap-3 text-muted-foreground">
        <Loader2 className="w-5 h-5 animate-spin" />
        <span className="text-sm">Signing you in…</span>
      </div>
    </div>
  );
}
